import ApiBase, { baseUrl } from '.';

export default class ElementServiceApi extends ApiBase {
  constructor(token) {
    super(`${baseUrl}/api/services/app/ElementService`, token);
  }

  get(id) {
    return this.authHttp.get(`${this.baseUrl}/Get`, { params: { id: id } });
  }

  create(element) {
    return this.authHttp.post(`${this.baseUrl}/Create`, element);
  }

  delete(id) {
    return this.authHttp.delete(`${this.baseUrl}/Delete`, {
      params: { id: id }
    });
  }

  reorder(element) {
    return this.authHttp.post(`${this.baseUrl}/Reorder`, element);
  }

  updateMeeting(element) {
    return this.authHttp.put(`${this.baseUrl}/UpdateMeeting`, element);
  }

  updateFile(element) {
    return this.authHttp.put(`${this.baseUrl}/UpdateFile`, element);
  }

  updateVideo(element) {
    return this.authHttp.put(`${this.baseUrl}/UpdateVideo`, element);
  }

  updateLesson(element) {
    return this.authHttp.put(`${this.baseUrl}/UpdateLesson`, element);
  }

  createMeeting(element) {
    return this.authHttp.post(`${this.baseUrl}/CreateMeeting`, element);
  }

  createFile(element) {
    return this.authHttp.post(`${this.baseUrl}/CreateFile`, element);
  }

  createVideo(element) {
    return this.authHttp.post(`${this.baseUrl}/CreateVideo`, element);
  }

  createLesson(element) {
    return this.authHttp.post(`${this.baseUrl}/CreateLesson`, element);
  }
}
